module.exports = __webpack_public_path__ + "static/hero-5-76d6ef5a4c35ed83d107b4a60bc3452c.jpg";